<div [formGroup]="form" class="raptor-mobile-container flex flex-items-center" [class]="{'raptor-mobile-select--disabled': question.settings?.country_alpha3.length === 1}">
  <div [formGroupName]="question.key" class="width-100 raptor-mobile-group">
    <mat-select panelWidth="auto" matPrefix formControlName="country" class="raptor-mobile-select input" panelClass="raptor-mobile-select-panel">
      <mat-option *ngFor="let country of countryList" [value]="country.code" class="input">
        {{ country.icon }} +{{ country.code }}
      </mat-option>
    </mat-select>
    
    <mat-form-field appearance="outline" class="raptor-mobile-form-field padding-bottom-none">
      <input matInput type="tel" formControlName="mobileNumber" [placeholder]="(question.settings && question.settings.placeholder)">
    </mat-form-field>
  </div>
</div>